import * as React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
// @ts-ignore
import { submittingSelectors } from 'shared';

// Selectors
import { makeSelectError } from 'services/error/selectors';
import { selectIsOnline } from 'services/connection/selectors';

interface Props {
    submitting?: boolean;
    error?: string;
    isOnline: boolean;
}

interface State {
    displaySuccessMessage: boolean;
    error: string;
}

export class SubmittingIndicator extends React.PureComponent<Props, State> {
    static defaultProps = {
        isOnline: true
    };

    state = {
        displaySuccessMessage: false,
        error: ''
    };

    componentDidUpdate(prevProps: Props) {
        if (prevProps.submitting && !this.props.submitting) {
            this.setState({ displaySuccessMessage: true }, () => {
                setTimeout(() => {
                    this.setState({ displaySuccessMessage: false });
                }, 5000);
            });
        }

        if (prevProps.error !== this.props.error) {
            this.setState({ error: this.props.error });
        }
    }

    render() {
        const { submitting, isOnline } = this.props;
        const { displaySuccessMessage, error } = this.state;

        if (submitting) {
            return 'Saving...';
        }
        if (error) {
            return (
                <span style={{ color: 'rgb(240, 64, 61)' }}>
                    {'Error: '}
                    {error}
                </span>
            );
        }
        if (error) return null;
        if (displaySuccessMessage) {
            return 'All changes saved';
        }

        if (!isOnline) {
            return 'Offline';
        }

        return null;
    }
}

const mapStateToProps = createStructuredSelector({
    submitting: submittingSelectors.makeSelectSubmitting(),
    error: makeSelectError(),
    isOnline: selectIsOnline
});

export default connect(mapStateToProps)(SubmittingIndicator);
